export default class TimeFormat {
	static format(seconds: number, toFixed = 0): string {
		const minutes = Math.floor(seconds / 60);
		const remainder = Math.floor(seconds - 60 * minutes);

		const time = (minutes > 0 ? minutes : "0") + ":" + (remainder < 10 ? "0" : "") + remainder.toFixed(toFixed);
		return time;
	}
}
